import React from 'react';

import Main from '../../layouts/Main';
import Hero from '../../components/Hero';

import {
  CTA,
  Segments,
  Stories
} from './components';

const IndustrySolutions = () => {
  return (
    <Main colorInvert={true}>
      <Hero />
      <Segments />
      <Stories />
      <CTA />



    </Main>
  );
};

export default IndustrySolutions;
